export default content => {
  const { display } = content
  if (!display || !display.css) return null

  return <style type="text/css">{display.css}</style>
}
